import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface OpenItemFilterState {
  startDate: string;
  endDate: string;
  selectPeriod: string;
  vendors: string[];
  categoryIds: string[];
  fromIds: string[];
  manualEntry: boolean;
  bankStatement: boolean;
  cashFlow: string;
  minAmount: string;
  maxAmount: string;
  hasNoVendors: boolean;
}

const initialState: OpenItemFilterState = {
  startDate: "",
  endDate: "",
  selectPeriod: "",
  vendors: [],
  categoryIds: [],
  fromIds: [],
  manualEntry: false,
  bankStatement: false,
  cashFlow: "",
  minAmount: "",
  maxAmount: "",
  hasNoVendors: false,
};

const openItemFilter = createSlice({
  name: "openItemFilter",
  initialState,
  reducers: {
    setOpenItemFilter: (
      state,
      action: PayloadAction<Partial<OpenItemFilterState>>
    ) => {
      return { ...state, ...action.payload };
    },
    resetOpenItemFilter: () => initialState,
  },
});

export const { setOpenItemFilter, resetOpenItemFilter } =
  openItemFilter.actions;

export default openItemFilter.reducer;
